module.exports = __webpack_public_path__ + "static/media/facebook.57b82be9.svg";